import api from '../api';

export type TimelinePeriod = '24h' | '7d' | '30d' | '90d' | '1y';
export type TimelineGroupBy = 'hour' | 'day' | 'week' | 'month';

export interface TimelinePoint {
  period: string;
  total: number;
  bots: number;
  humans: number;
}

export interface TimelineResponse {
  period: TimelinePeriod;
  group_by: TimelineGroupBy;
  data: TimelinePoint[];
}

export interface TopCampaign {
  id: number;
  name: string;
  account_id: number | null;
  account_name: string;
  status: string;
  requests_count: number;
  bot_count: number;
  human_count: number;
  bot_percentage: number;
}

export interface TopCampaignsResponse {
  period: string;
  data: TopCampaign[];
}

export interface SubscriptionUsageItem {
  account_id: number;
  account_name: string;
  account_status: string;
  plan_name: string;
  requests_used: number;
  requests_limit: number | null;
  requests_remain: number | null;
  usage_pct: number | null;
}

export interface SubscriptionUsageResponse {
  year: number;
  month: number;
  data: SubscriptionUsageItem[];
  total_used: number;
  total_limit: number;
}

export const requestStatsService = {
  async getTimeline(period: TimelinePeriod, groupBy: TimelineGroupBy): Promise<TimelineResponse> {
    const response = await api.get<TimelineResponse>('/api/admin/request-stats/timeline', {
      params: { period, group_by: groupBy },
    });
    return response.data;
  },

  async getTopCampaigns(period: string, limit = 50): Promise<TopCampaignsResponse> {
    const response = await api.get<TopCampaignsResponse>('/api/admin/request-stats/top-campaigns', {
      params: { period, limit },
    });
    return response.data;
  },

  async getSubscriptionUsage(): Promise<SubscriptionUsageResponse> {
    const response = await api.get<SubscriptionUsageResponse>('/api/admin/request-stats/subscription-usage');
    return response.data;
  },
};
